module.exports = __webpack_public_path__ + "img/oyster_ship.cbfc355d.webp";